import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { fetchPropertyDetailsAction, updatePropertyDetails, updatePropertyDetailsLoading } from '../store/reducer/propertyDetailSlice';

export const usePropertyDetilas = () => {
  const { propertyType, propertyId } = useParams();

  useEffect(() => {
    fetchPropertyDetails();

    return () => {
      dispatch(updatePropertyDetailsLoading(true));
      dispatch(updatePropertyDetails({}));
    };
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const onFetchFail = () => {
    if (location?.state?.prevPath) {
      navigate(location.state.prevPath);
      return;
    }
    navigate(`/marketplace/${propertyType}`);
  };
  async function fetchPropertyDetails() {
    await dispatch(fetchPropertyDetailsAction({ id: propertyId, onFail: onFetchFail }));
  }

  return {
    fetchPropertyDetails,
  };
};
